import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import userActions from "../ducks/user/actions";

import MapAddress from "../components/MapAddress";
import { showMessage } from "react-native-flash-message";
import useNavigation from "../hooks/useNavigation";
import { Helmet } from "react-helmet";
import { Platform } from "react-native";
import useSyncFilterWithParam from "../hooks/useSyncFilterWithParam";

function NewAddress() {
  let dispatch = useDispatch();
  let nav = useNavigation();
  let { setParam, params } = useSyncFilterWithParam();
  let origin_page = params?.origin_page;
  let orderId = params?.order_id;

  let handleOnPress = () => {
    nav.jumpAndNavigate({
      jumpTo: "Orders",
      navigateTo: "OrderView",
      navigateParams: {
        order_id: orderId,
        added_address: "true",
      },
    });
  };

  function handleSave({
    onEnd,
    region: { latitude, longitude },
    address,
    title,
  }) {
    const data = { latitude, longitude, address, title };
    dispatch(
      userActions.add_address_request({
        onSuccess: () => {
          if (nav.canGoBack) {
            if (Platform.OS === "web") {
              if (origin_page === "Basket") {
                nav.navigate("Basket");
                setParam({ name: "added_address", value: "true" });
              } else if (origin_page === "Order") {
                if (!orderId) {
                  nav.navigate("Orders");
                } else {
                  handleOnPress();
                }
              } else {
                nav.navigate("UserAddresses");
              }
            } else if (Platform.OS === "android") {
              if (origin_page === "Basket") {
                nav.navigate("Basket", {
                  added_address: "true",
                });
              } else if (origin_page === "Order") {
                if (!orderId) {
                  nav.navigate("Orders");
                } else {
                  handleOnPress();
                }
              } else {
                nav.navigate("UserAddresses");
              }
            } else {
              nav.goBack();
            }
          } else {
            nav.navigate("Profile");
          }
          onEnd();

          showMessage({
            type: "success",
            message: "آدرس با موفقیت افزوده شد.",
          });
        },
        onFailed: () => {
          showMessage({
            type: "danger",
            message: "مشکلی در ثبت آدرس پیش آمده است.",
          });
          onEnd();
        },
        ...data,
      })
    );
  }

  return (
    <>
      <Helmet>
        <title>افزودن آدرس | دیجی واش</title>
      </Helmet>
      <MapAddress onSave={handleSave} />
    </>
  );
}

export default NewAddress;
